// extracted by mini-css-extract-plugin
module.exports = {"txInfo":"styles_txInfo__eFw8y"};